import React from "react";
import { Filter, Eye, X } from "lucide-react";
import { FaSort, FaSortUp, FaSortDown, FaEye } from "react-icons/fa";

import Pagination from "../../components/Pagination/Pagination";
import {
  formatCurrency,
  formatDate,
  mapStatusToBootstrap,
} from "../../components/Constants/Constants";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../components/AppLoader/appLoader";
// import UnAuthorized from "../UnAuthorized/UnAuthorized";
// import usePermission from "../../utils/usePermission";
import { useMiscSettlement } from "../../customHooks/MiscSettlement/useMiscSettlement";
import CopyIcon from "../../components/CopyIcon/CopyIcon";

const MiscSettlement = () => {
  const {
    settlements,
    loading,
    totalOrderCount,
    filters,
    setFilters,
    handleFilterChange,
    clearFilters,
    sortConfig,
    handleSort,
    paginatedSettlements,
    totalPages,
    currentPage,
    startItem,
    endItem,
    goToPage,
    itemsPerPage,
    itemsPerPageOptions,
    handleItemsPerPageChange,
    filterOptions, // Include dynamic filters
    selectedOption,
    setSelectedOption,
    searchValue,
    setSearchValue,
    handleDropdownChange,
    handleSearchChange,
    searchOptions,
  } = useMiscSettlement();

  //   const canViewSettlements = usePermission("SETTLEMENT_LISTING_VIEW");

  const navigate = useNavigate();
  return (
    <>
      {/* {canViewSettlements ? ( */}
      <div>
        {/* {selectedOrders.length > 0 && (
      <div className="d-flex justify-content-end align-items-center mt-2">

        <button
          className="btn btn-primary d-flex align-items-center"
          style={{ padding: "4px 8px", fontSize: "14px" }}
          onClick={sendSettlementRequest}
        >
          Send Settlement Request
        </button>
      </div>
      )} */}

        <div className="filters-wrapper bg-white px-3 py-2 rounded shadow-sm">
          <div className="row gx-4 gy-3 align-items-end flex-wrap">
            {/* Search Section */}
            <div className="col-auto">
              <label className="form-label mb-1" style={{ fontSize: "0.8rem" }}>
                Search By
              </label>
              <div className="d-flex align-items-center">
                <select
                  className="form-select"
                  value={selectedOption}
                  onChange={handleDropdownChange}
                  style={{
                    width: "150px",
                    borderTopRightRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                >
                  {searchOptions?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <input
                  type="text"
                  className="form-control"
                  value={searchValue}
                  onChange={handleSearchChange}
                  placeholder={`${selectedOption
                    .split("_") // Split by underscores
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
                    .join(" ")}`} // Join words back with a space
                  style={{
                    width: "200px",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                  }}
                />
              </div>
            </div>

            {/* Dynamic Filters */}
            {/* Buyer App */}
            {/* <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Buyer App
                </label>
                <select
                  className="form-select"
                  value={filters.buyer_app_id || ""}
                  onChange={(e) =>
                    handleFilterChange("buyer_app_id", e.target.value)
                  }
                  style={{ minWidth: "140px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.buyerAppIds?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div> */}

            {/* Seller App */}
            {/* <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Seller App
                </label>
                <select
                  className="form-select"
                  value={filters.seller_app_id || ""}
                  onChange={(e) =>
                    handleFilterChange("seller_app_id", e.target.value)
                  }
                  style={{ minWidth: "140px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.sellerAppIds?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div> */}
            <div className="col-auto">
              <label className="form-label mb-1" style={{ fontSize: "0.8rem" }}>
                Provider Status
              </label>
              <select
                className="form-select"
                value={filters.provider_status || ""}
                onChange={(e) =>
                  handleFilterChange("provider_status", e.target.value)
                }
                style={{ minWidth: "140px" }}
              >
                <option value="">All</option>
                {filterOptions?.providerStatuses?.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-auto">
              <label className="form-label mb-1" style={{ fontSize: "0.8rem" }}>
                Self Status
              </label>
              <select
                className="form-select"
                value={filters.self_status || ""}
                onChange={(e) =>
                  handleFilterChange("self_status", e.target.value)
                }
                style={{ minWidth: "140px" }}
              >
                <option value="">All</option>
                {filterOptions?.selfStatuses?.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            {/* Settlement Status */}
            <div className="col-auto">
              <label className="form-label mb-1" style={{ fontSize: "0.8rem" }}>
                Settlement Status
              </label>
              <select
                className="form-select"
                value={filters.settlement_status || ""}
                onChange={(e) =>
                  handleFilterChange("settlement_status", e.target.value)
                }
                style={{ minWidth: "120px" }}
              >
                <option value="">All</option>
                {filterOptions?.settlementStatuses?.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-auto">
              <label
                className="form-label mb-1.5"
                style={{ fontSize: "0.8rem" }}
              >
                Order Created Between
              </label>
              <div className="d-flex flex-wrap gap-3">
                {/* FROM Date */}
                <div
                  className="position-relative"
                  style={{ minWidth: "130px" }}
                >
                  <label
                    style={{
                      position: "absolute",
                      top: "-10px",
                      left: "10px",
                      background: "#fff",
                      fontSize: "0.7rem",
                      padding: "0 4px",
                      zIndex: 1,
                      color: "#6c757d",
                    }}
                  >
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={filters.settlement_created_at_from}
                    onChange={(e) =>
                      handleFilterChange(
                        "settlement_created_at_from",
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* TO Date */}
                <div
                  className="position-relative"
                  style={{ minWidth: "130px" }}
                >
                  <label
                    style={{
                      position: "absolute",
                      top: "-10px",
                      left: "10px",
                      background: "#fff",
                      fontSize: "0.75rem",
                      padding: "0 4px",
                      zIndex: 1,
                      color: "#6c757d",
                    }}
                  >
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={filters.settlement_created_at_to}
                    onChange={(e) =>
                      handleFilterChange(
                        "settlement_created_at_to",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </div>

            {/* Clear Filters Button */}
            <div className="col-auto">
              <button
                type="button"
                className="clearFilter d-flex align-items-center"
                onClick={clearFilters}
              >
                <i className="bi bi-x-circle me-1"></i>
                Reset Filters
              </button>
            </div>
          </div>
        </div>

        {/* Orders table */}
        {loading ? (
          <AppLoader />
        ) : (
          <>
            <div
              className="table-responsive mt-4"
              style={{ overflowX: "auto" }}
            >
              <table
                className="table table-bordered table-hover align-middle"
                style={{ minWidth: "1200px" }}
              >
                <thead className="table-light">
                  <tr>
                    <th style={{ minWidth: "150px" }}>Settlement ID</th>
                    <th style={{ minWidth: "150px" }}>Settlement Txn. ID</th>
                    <th style={{ minWidth: "100px" }}>Provider ID</th>
                    <th style={{ minWidth: "200px" }}>Provider Name</th>
                    <th style={{ minWidth: "150px" }}>Provider Amount</th>
                    <th style={{ minWidth: "150px" }}>Provider Status</th>
                    <th style={{ minWidth: "150px" }}>Self Amount</th>
                    <th style={{ minWidth: "150px" }}>Self Status</th>

                    <th
                      style={{ minWidth: "150px" }}
                      onClick={() => handleSort("createdAt")}
                      role="button"
                    >
                      Created At &nbsp;
                      {sortConfig.key === "createdAt" ? (
                        sortConfig.direction === "asc" ? (
                          <FaSortUp size={14} />
                        ) : (
                          <FaSortDown size={14} />
                        )
                      ) : (
                        <FaSort size={14} />
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedSettlements && paginatedSettlements.length > 0 ? (
                    paginatedSettlements.map((settlement, index) => (
                      <tr key={`${settlement.settlement_id}-${index}`}>
                        <td className="copy-cell" style={{ minWidth: "150px" }}>
                          <span
                            onClick={() =>
                              navigate(
                                `/misc-settlements-detail/${settlement.settlement_id}`
                              )
                            }
                            style={{
                              cursor: "pointer",
                              color: "#0d6efd",
                              fontWeight: 500,
                              textDecoration: "none",
                            }}
                            title="View Settlements Details"
                            className="truncate-cell"
                          >
                            {settlement.settlement_id}
                          </span>
                          <CopyIcon textToCopy={settlement.settlement_id} />{" "}
                          {/* <-- Added Copy Icon */}
                        </td>
                        <td className="copy-cell" style={{ minWidth: "150px" }}>
                          <span className="truncate-cell">
                            {settlement.settlement_txn_id}
                          </span>
                          <CopyIcon textToCopy={settlement.settlement_txn_id} />
                        </td>
                        <td style={{ minWidth: "100px" }}>
                          {settlement?.order?.provider.id}
                        </td>
                        <td style={{ minWidth: "200px" }}>
                          {settlement?.order?.provider?.name}
                        </td>
                        <td style={{ minWidth: "150px" }}>
                          {formatCurrency(
                            settlement?.order?.provider?.amount?.value
                          )}
                        </td>
                        <td style={{ minWidth: "150px" }}>
                          {settlement?.order?.provider?.status}
                        </td>
                        <td style={{ minWidth: "150px" }}>
                          {formatCurrency(
                            settlement?.order?.self?.amount?.value
                          )}
                        </td>
                        <td style={{ minWidth: "150px" }}>
                          {settlement?.order?.self?.status}
                        </td>

                        <td style={{ minWidth: "150px" }}>
                          {formatDate(settlement.createdAt)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={11}
                        className="text-center py-4 text-gray-500"
                      >
                        No Settlements Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}

        {/* Pagination */}
        {totalOrderCount > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            startItem={startItem}
            endItem={endItem}
            totalItems={totalOrderCount}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            onPageChange={goToPage}
            itemsPerPageOptions={itemsPerPageOptions}
          />
        )}
      </div>
      {/* //   ) : (
    //     <UnAuthorized />
    //   )} */}
    </>
  );
};

export default MiscSettlement;
